import React, { Component } from 'react'
import Sidebar from './Sidebar';
import store from '../../../store';
import { translate } from 'react-multi-lang'
import { connect } from 'react-redux';
import { chunk } from '../../../helpers'
import {
    setSelfEmploymentSearchResults,
    postSelfEmploymentSearch,
    applySelfEmployment,
    get_jobseekerAddress,
    get_jobseeker_profile,
    postPmSchemeSearch
} from
    '../../../actions/jobseekerAction';
import {
    getEducationLevel, get_org_category, get_genders,
    getSelfEmpDropDownData, get_User_District,
    get_User_Subistrict, get_User_Cities, set_User_SubDistrict,
    getTradeData
} from '../../../actions/accountAction'
import { get_sector_self_employment } from '../../../actions/jobpostAction'
import Pagination from "react-js-pagination";
import { Link } from 'react-router'
import ServerSetting from '../../../config.json'


const RESULT_PER_PAGE = 25
const BASIC_SEARCH = 1

class SearchPmScheme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: [],
            formData1: [],
            job: [],
            jobDetails: false,
            activePage: 1,
            submit: false,
            submitProfile: false,
            data: [],
            searchType: 2,
            course_ids: []
        }

        // store.dispatch(getTradeData());

        // store.dispatch(get_jobseeker_profile());
        // store.dispatch(get_jobseekerAddress());
        store.dispatch(get_User_District())
        // store.dispatch(getSelfEmpDropDownData())
        // store.dispatch(get_genders());
        // store.dispatch(get_sector_self_employment());
        // store.dispatch(get_org_category());
        // store.dispatch(getEducationLevel());
    }

    componentDidMount() {
        document.title = this.props.t('pmVikasRojgar.searchPmScheme', { param: 'react' })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (Object.keys(nextProps.JobseekerReducer.Profile).length > 0 && nextProps.JobseekerReducer.Addresses &&
            Object.keys(nextProps.JobseekerReducer.Addresses.current).length > 0 && nextProps.actionReducer.educationLevel.length
            && !this.state.sundirectoryload) {
            const formData1 = this.state.formData1
            if (nextProps.JobseekerReducer.Addresses.current.district_id) {
                store.dispatch(get_User_Subistrict(nextProps.JobseekerReducer.Addresses.current.district_id));
                store.dispatch(get_User_Cities(nextProps.JobseekerReducer.Addresses.current.subdistrict_id));
                formData1['district_id'] = nextProps.JobseekerReducer.Addresses.current.district_id
            }
            formData1['education_level'] = nextProps.JobseekerReducer.Profile.highest_education_level
            formData1['subdistrict_id'] = nextProps.JobseekerReducer.Addresses.current.subdistrict_id
            const educationLevel = nextProps.actionReducer.educationLevel
            const data = []
            const selectedEducation = educationLevel.filter((edu) => edu.education_id === nextProps.JobseekerReducer.Profile.highest_education_level)
            if (selectedEducation && selectedEducation[0]) {
                selectedEducation && selectedEducation[0] && selectedEducation[0].qualification.forEach((qual) => {
                    data.push({ label: qual.name, id: qual.id })
                })
                this.setState({ data })
            }
            this.setState({ sundirectoryload: true, formData1 });
        }
    }

    handlePageChange = (activePage) => {
        this.setState({ activePage })
    }

    createDistoption = () => {
        let Mainprops = this.props;
        let Distoption = []
        if (Mainprops.actionReducer.District.length > 0) {
            Mainprops.actionReducer.District.map((data) => {
                if (data.state_id === "3") {
                    data.dist.map(function (distdata, distindex) {
                        if (distindex) {
                            Distoption.push(<option key={distindex} value={distdata.id}>{distdata.name}</option>)
                            return Distoption
                        }
                        return ''
                    })
                }
                return Distoption
            })
        }
        return Distoption
    }

    applyForJob = (job) => {
        store.dispatch(applySelfEmployment(job.id))
        this.setState({ job })
    }

    componentWillUnmount() {
        store.dispatch(setSelfEmploymentSearchResults([]))
    }

    handleInput = async (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let formData = this.state.formData;
        if (name === 'district_id') {
            store.dispatch(get_User_Subistrict(value));
            delete formData['subdistrict_id']
        }
        if (name === 'subdistrict_id') {
            store.dispatch(get_User_Cities(value));
            delete formData['city']
        }
        formData[name] = value;
        if (!value) {
            delete formData[name]
        }
        await this.setState({ formData, submit: false });
    }

    handleInputProfile = async (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let formData1 = this.state.formData1;
        if (name === 'district_id') {
            store.dispatch(getTradeData(value));
            store.dispatch(get_User_Subistrict(value));
            delete formData1['subdistrict_id']
        }
        if (name === 'subdistrict_id') {
            store.dispatch(get_User_Cities(value));
            this.setState({ data: [] })
        }
        formData1[name] = value;
        if (!value) {
            delete formData1[name]
        }
        await this.setState({ formData1, submitProfile: false });
    }

    submit = (e) => {
        e.preventDefault()
        if (!this.state.submit) {
            store.dispatch(postSelfEmploymentSearch({ auth_key: localStorage.getItem('token'), ...this.state.formData }));
            this.setState({ submit: true })
        }
    }

    // submitProfile = (e) => {
    //     e.preventDefault()
    //     if (!this.state.submitProfile) {
    //         store.dispatch(postPmSchemeSearch({ auth_key: localStorage.getItem('token'), ...this.state.formData1 }));
    //         this.setState({ submitProfile: true })
    //     }
    // }


    submitProfile = (e) => {
        e.preventDefault();

        if (!this.state.submitProfile) {
            const payload = {
                auth_key: localStorage.getItem('token'),
                district_id: this.state.formData1.district_id || '',
                course_ids: this.state.formData1.course_ids || [] // ensure it's always an array
            };


            // Dispatch API call
            store.dispatch(postPmSchemeSearch(payload));

            this.setState({ submitProfile: true });
        }
    };




    setSearchType = (searchType) => {
        if (searchType === BASIC_SEARCH) {
            this.setState({ formData: [] })
            store.dispatch(set_User_SubDistrict([]))
        } else {
            store.dispatch(get_User_Subistrict(this.state.formData1.district_id))
        }
        this.setState({ searchType })
    }

    render() {
        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }


        const Mainprops = this.props
        const { activePage, job, formData, searchType } = this.state
        const searchResults = chunk(this.props.JobseekerReducer.postPmResults.applied, RESULT_PER_PAGE)
        const appliedIds = new Map(Mainprops.JobseekerReducer.appliedSelfEmployment?.map((item) => [item.employment_id, item.applied_on]));
        const dropDownData = Mainprops.actionReducer.dropDownData

        const SERVER_PATH = ServerSetting[process.env.NODE_ENV].SERVER_PATH;

        const education = []
        const loan_purpose = []
        const loan_type = []
        const projects_covered = []
        const repaying_period = []
        const scheme_name = []
        const experience = []
        const subsidy = []
        const training_required = []

        if (dropDownData && dropDownData.length) {
            dropDownData.forEach((data) => {
                education.push(data.education)
                loan_purpose.push(data.loan_purpose)
                loan_type.push(data.loan_type)
                projects_covered.push(data.projects_covered)
                repaying_period.push(data.repaying_period)
                scheme_name.push(data.scheme_name)
                subsidy.push(data.subsidy)
                training_required.push(data.training_required)
                experience.push(data.experience)
            })
        }

        const data = []
        if (formData.education_level) {
            const educationLevel = this.props.actionReducer.educationLevel
            const selectedEducation = educationLevel.filter((edu) => edu.education_id === formData.education_level)
            if (selectedEducation && selectedEducation[0]) {
                selectedEducation && selectedEducation[0] && selectedEducation[0].qualification.forEach((qual) => {
                    data.push({ label: qual.name, id: qual.id })
                })
            }
        }

        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={Mainprops.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">

                            <div className="clearfix"></div>
                            <div>
                                <div className="w-100 pull-left">
                                    <div className="tab-content  w-100 float-left mb-3">
                                        <div className="modal fade" id="descriptionModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                                            <div className="modal-dialog" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-body">
                                                        <h6>{this.props.t('counsellingProvider.details', { param: 'react' })}</h6>
                                                        {job.projects_covered ? <p>{this.props.t('selfEmployment.Project', { param: 'react' })}: {job.projects_covered}</p> : ''}
                                                        {job.education_level ? <p>{this.props.t('selfEmployment.Education Level', { param: 'react' })} : {job.education_level}</p> : ''}
                                                        {job.qualification ? <p>{this.props.t('selfEmployment.Qualification', { param: 'react' })}  : {job.qualification}</p> : ''}
                                                        {job.training_required ? <p>{this.props.t('selfEmployment.Training', { param: 'react' })}: {job.training_required}</p> : ''}
                                                        {job.experience ? <p>{this.props.t('selfEmployment.Experience (In Years)', { param: 'react' })} : {job.experience}</p> : ''}
                                                        {job.collateral_required ? <p>{this.props.t('selfEmployment.Can you offer collateral', { param: 'react' })}: {job.collateral_required && job.collateral_required === "1" ? "Yes" : "No"}</p> : ''}
                                                        {job.defaulter ? <p>{this.props.t('selfEmployment.Have you defaulted against a loan in past', { param: 'react' })}: {job.defaulter && job.defaulter === "1" ? "Yes" : "No"}</p> : ''}
                                                        {job.collateral_required ? <p>{this.props.t('selfEmployment.Can you offer collateral', { param: 'react' })}: {job.collateral_required && job.collateral_required === "1" ? "Yes" : "No"}</p> : ''}
                                                        {job.loan_type ? <p>{this.props.t('selfEmployment.Type of Loan', { param: 'react' })}: {job.loan_type}</p> : ''}
                                                        {job.loan_purpose ? <p>{this.props.t('selfEmployment.Purpose of Loan', { param: 'react' })}: {job.loan_purpose}</p> : ''}
                                                        {job.repaying_period ? <p>{this.props.t('selfEmployment.Repaying Period', { param: 'react' })}: {job.repaying_period}</p> : ''}
                                                        {job.family_income ? <p>{this.props.t('selfEmployment.Annual Family Income (In INR)', { param: 'react' })}: {job.family_income} </p> : ''}
                                                        {job.subdistrict_id ? <p>{this.props.t('selfEmployment.Block Name', { param: 'react' })}: {job.subdistrict_id}</p> : ''}
                                                        {job.description ? <p>{this.props.t('dashboard.table.description', { param: 'react' })}: {job.description}</p> : ''}
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button
                                                            aria-label='Close Job Details'
                                                            type="button" className="btn btn-primart btn-primary2" data-dismiss="modal">
                                                            {this.props.t('counsellingProvider.close', { param: 'react' })}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="home" className=" tab-pane active">
                                            <section className="login-form mt-0">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-lg-12  mx-auto   p-0">
                                                            <div className="panel-heading">
                                                                <h6 className="mb-0">{this.props.t('pmVikasRojgar.searchPmScheme', { param: 'react' })}</h6>
                                                            </div>

                                                            <div className="panel-body">
                                                                <form onSubmit={this.submitProfile}>
                                                                    <div className="form-group row">
                                                                        <div className="col-md-6">
                                                                            <div className="row">
                                                                                <div className="col-sm-4">
                                                                                    <label>{this.props.t('JobPost.district', { param: 'react' })}</label>
                                                                                </div>

                                                                                <div className="col-sm-8 col-lg-8 form-group">
                                                                                    <select onChange={(event) => this.handleInputProfile(event)}
                                                                                        value={this.state.formData1.district_id ? this.state.formData1.district_id : ""}
                                                                                        name="district_id" className="form-control" aria-label="Select District">
                                                                                        <option value={""}>{this.props.t('profileDetails.selectDistrict', { param: 'react' })}</option>
                                                                                        {this.createDistoption()}
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="row">
                                                                                <div className="col-sm-4">
                                                                                    <label>{this.props.t('pmVikasRojgar.trade', { param: 'react' })}</label>
                                                                                </div>
                                                                                <div className="col-sm-8 col-lg-8 form-group">


                                                                                    {/* <div className="form-group">
                                                                                        <div className="row">
                                                                                            <div style={{ position: "relative", width: "100%" }}>
                                                                                                <div
                                                                                                    onClick={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}
                                                                                                    style={{
                                                                                                        border: "1px solid #ccc",
                                                                                                        padding: "8px",
                                                                                                        borderRadius: "4px",
                                                                                                        cursor: "pointer",
                                                                                                        background: "#fff"
                                                                                                    }}
                                                                                                >
                                                                                                    {this.state.formData.education_level?.length > 0
                                                                                                        ? `${this.state.formData.education_level.length} selected`
                                                                                                        : this.props.t('pmVikasRojgar.selectTrade', { param: 'react' })}
                                                                                                </div>

                                                                                                {this.state.dropdownOpen && (
                                                                                                    <div
                                                                                                        style={{
                                                                                                            position: "absolute",
                                                                                                            top: "100%",
                                                                                                            left: 0,
                                                                                                            right: 0,
                                                                                                            border: "1px solid #ccc",
                                                                                                            background: "#fff",
                                                                                                            zIndex: 1000,
                                                                                                            maxHeight: "200px",
                                                                                                            overflowY: "auto",
                                                                                                        }}
                                                                                                    >
                                                                                                        {Mainprops.actionReducer.tradeData.length > 0 &&
                                                                                                            Mainprops.actionReducer.tradeData.map((data, index) => (
                                                                                                                <label
                                                                                                                    key={index}
                                                                                                                    style={{
                                                                                                                        display: "flex",
                                                                                                                        alignItems: "center",
                                                                                                                        padding: "6px 10px",
                                                                                                                        cursor: "pointer",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <input
                                                                                                                        type="checkbox"
                                                                                                                        checked={
                                                                                                                            this.state.formData.education_level?.includes(data.id) || false
                                                                                                                        }
                                                                                                                        onChange={(e) => {
                                                                                                                            let selected = this.state.formData.education_level || [];
                                                                                                                            if (e.target.checked) {
                                                                                                                                selected = [...selected, data.id];
                                                                                                                            } else {
                                                                                                                                selected = selected.filter((val) => val !== data.id);
                                                                                                                            }
                                                                                                                            this.setState({
                                                                                                                                formData: {
                                                                                                                                    ...this.state.formData,
                                                                                                                                    education_level: selected,
                                                                                                                                },
                                                                                                                            });
                                                                                                                        }}
                                                                                                                    />
                                                                                                                    <span style={{ marginLeft: "8px" }}>{data.course}</span>
                                                                                                                </label>
                                                                                                            ))}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div> */}


                                                                                    <div className="form-group">
                                                                                        <div className="row">
                                                                                            <div style={{ position: "relative", width: "100%" }}>
                                                                                                <div
                                                                                                    onClick={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}
                                                                                                    style={{
                                                                                                        border: "1px solid #ccc",
                                                                                                        padding: "8px",
                                                                                                        borderRadius: "4px",
                                                                                                        cursor: "pointer",
                                                                                                        background: "#fff"
                                                                                                    }}
                                                                                                >
                                                                                                    {this.state.formData1.course_ids?.length > 0
                                                                                                        ? `${this.state.formData1.course_ids.length} selected`
                                                                                                        : this.props.t('pmVikasRojgar.selectTrade', { param: 'react' })}
                                                                                                </div>

                                                                                                {this.state.dropdownOpen && (
                                                                                                    <div
                                                                                                        style={{
                                                                                                            position: "absolute",
                                                                                                            top: "100%",
                                                                                                            left: 0,
                                                                                                            right: 0,
                                                                                                            border: "1px solid #ccc",
                                                                                                            background: "#fff",
                                                                                                            zIndex: 1000,
                                                                                                            maxHeight: "200px",
                                                                                                            overflowY: "auto",
                                                                                                        }}
                                                                                                    >
                                                                                                        {Mainprops.actionReducer.tradeData.length > 0 &&
                                                                                                            Mainprops.actionReducer.tradeData.map((data, index) => (
                                                                                                                <label
                                                                                                                    key={index}
                                                                                                                    style={{
                                                                                                                        display: "flex",
                                                                                                                        alignItems: "center",
                                                                                                                        padding: "6px 10px",
                                                                                                                        cursor: "pointer",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <input
                                                                                                                        type="checkbox"
                                                                                                                        checked={this.state.formData1.course_ids?.includes(data.id) || false}
                                                                                                                        onChange={(e) => {
                                                                                                                            let selected = [...(this.state.formData1.course_ids || [])];
                                                                                                                            if (e.target.checked) {
                                                                                                                                selected.push(data.id);
                                                                                                                            } else {
                                                                                                                                selected = selected.filter((val) => val !== data.id);
                                                                                                                            }

                                                                                                                            this.setState({
                                                                                                                                formData1: {
                                                                                                                                    ...this.state.formData1,
                                                                                                                                    course_ids: selected
                                                                                                                                }
                                                                                                                            });
                                                                                                                        }}
                                                                                                                    />
                                                                                                                    <span style={{ marginLeft: "8px" }}>{data.course}</span>
                                                                                                                </label>
                                                                                                            ))}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr></hr>
                                                                    <div className="form-group row">
                                                                        <div className="col-sm-12 ">
                                                                            <button
                                                                                aria-label='Submit Profile Specific Search Form'
                                                                                type="submit"
                                                                                className="mx-auto d-block btn btn-primary btn-primary2 mt-1">
                                                                                {this.props.t('pmVikasRojgar.apply', { param: 'react' })}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                                <div className="clear-fix"></div>
                                {this.props.JobseekerReducer.postPmResults.applied && this.props.JobseekerReducer.postPmResults.applied.length > 0 &&
                                    <div className="tab-content  w-100 float-left">
                                        <div id="home" className=" tab-pane active">
                                            <section className="login-form mt-0">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-md-12  mx-auto   p-0">
                                                            <div className="panel-heading">
                                                                <h6 className="mb-0">{this.props.t('jobSearch.results',
                                                                    { param: 'react' })}</h6>
                                                            </div>
                                                            <div className="panel-body">
                                                                <div className="">
                                                                    {searchResults && searchResults.length > 0 && searchResults[activePage - 1].map((job, key) => {

                                                                        const appliedOn = appliedIds.get(job.id); // undefined if not applied
                                                                        const isApplied = !!appliedOn;
                                                                        return (
                                                                            <div className="right-sidebar" key={key}>
                                                                                <div className="first-job mb-3 p-3">
                                                                                    <div className="row">
                                                                                        <div className="col-md-10">
                                                                                            <h6 className="pt-1 company-name2 pb-1 mb-0 "><Link>
                                                                                                {this.props.t('selfEmployment.name', { param: 'react' })}: {job.course_name}     </Link></h6>
                                                                                            <div className="row w-100">
                                                                                                <div className="col-md-6 mb-1">
                                                                                                    <span className="pr-2 date-clr">{this.props.t('pmVikasRojgar.districtName', { param: 'react' })}: <span>
                                                                                                        {job.district_name} </span></span>
                                                                                                </div>
                                                                                                <div className="col-md-6 mb-1 pl-0">
                                                                                                    <span className="pr-2 date-clr">{this.props.t('pmVikasRojgar.courseName', { param: 'react' })}: <span>
                                                                                                        {job.course_name} </span></span>
                                                                                                </div>
                                                                                            </div>



                                                                                        </div>
                                                                                        {/* <div className="col-md-2 pl-0">
                                                                                            <div className="text-right rightalign">
                                                                                                {!isApplied ?
                                                                                                    <button
                                                                                                        aria-label='Apply for this job'
                                                                                                        type='button'
                                                                                                        onClick={() => this.applyForJob(job)}
                                                                                                        className="btn btn-primary intersted btn-primary2 pull-right">

                                                                                                        {this.props.t('counsellingProvider.I am interested', { param: 'react' })}
                                                                                                    </button> : <h6 className="date-clr pull-right">{this.props.t('selfEmployment.interestedAlready', { param: 'react' })} <br></br>
                                                                                                        {this.props.t('selfEmployment.interestShown', { param: 'react' })} {appliedOn}</h6>}
                                                                                                <Link data-target="#descriptionModal"
                                                                                                    onClick={() => this.setState({ job })}
                                                                                                    data-toggle="modal" style={{ "cursor": "pointer" }} className="date-clr pull-right" >
                                                                                                    {this.props.t('jobSearch.viewDetails', { param: 'react' })}
                                                                                                </Link>
                                                                                            </div>
                                                                                        </div> */}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                    {/* {searchResults && searchResults.length > 1 ? <div className='react-pagination'>
                                                                        <Pagination
                                                                            pageRangeDisplayed={10}
                                                                            activePage={activePage}
                                                                            itemsCountPerPage={RESULT_PER_PAGE}
                                                                            totalItemsCount={Mainprops.JobseekerReducer.selfEmployment.length}
                                                                            onChange={this.handlePageChange}
                                                                        />
                                                                    </div> : ''} */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>}

                                {Mainprops?.JobseekerReducer?.selfEmployment?.status === '401' && <div className="tab-content w-100 float-left">
                                    <div id="home" className=" tab-pane active">
                                        <section className="login-form mt-0">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-md-12  mx-auto   p-0">
                                                        <div className="panel-heading">
                                                            <h6 className="mb-0">{this.props.t('jobSearch.results',
                                                                { param: 'react' })}</h6>
                                                        </div>
                                                        <div className="panel-body">
                                                            <h3>{this.props.t('JobPost.notFound', { param: 'react' })}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>}
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = store => {
    return store;
};

export default connect(mapStateToProps)(translate(SearchPmScheme));

